import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslate } from 'react-admin';

import { TypographyTranslated } from '@sh4res/bo-common/components';
import { PageTitle } from '@sh4res/bo-common/components/PageTitle';

import { AxaTypography } from '@Components/AxaTypography';
import { LoginPageCTASecondary } from '@Components/LoginPageCTA';

const AddAlternateEmailPageFormWrapper = styled('div')`
  text-align: center;
  display: flex;
  flex-direction: column;
  min-width: 290px;
  max-width: min-content;
`;

const SUPPORT_PHONE_NUMBER = '09 70 80 85 95';

export function AddAlternateEmailPageForm({ onBackToLogin }: { onBackToLogin: () => void }) {
  const translate = useTranslate();
  const testId = 'BoExternalAddAlternateEmailPageForm';
  const rawHeaderText = 'login_page.messages.add_alternate_email.title';

  return (
    <>
      <PageTitle title={translate(rawHeaderText)} />
      <AddAlternateEmailPageFormWrapper>
        <Stack direction="row" gap={2} justifyContent="center">
          <Box component="svg" width={63} height={63} viewBox="0 0 63 63" fill="none">
            <path
              d="M6.99958 1.80678C10.3399 -1.04113 15.3936 -0.453745 17.9924 3.0851C18.1711 3.3286 18.371 3.65568 18.773 4.30613L22.4576 10.268C23.5044 11.9619 24.0294 12.8102 24.2444 13.6483C24.6639 15.2857 24.3309 17.0249 23.3385 18.3927C22.458 19.6057 21.0496 20.4094 19.8723 21.311C19.0271 22.0136 19.0965 23.0859 19.5465 24.0145H19.5393C21.5682 28.6439 34.9615 41.9569 39.133 43.0747C40.1948 43.2909 40.8371 42.6109 41.4068 41.8465C42.5963 40.2505 43.1917 39.4505 43.8918 38.9425C45.2599 37.9504 46.9988 37.6201 48.6363 38.0402C49.4744 38.2552 50.3227 38.7766 52.0165 39.8234L57.9784 43.508C58.6303 43.9108 58.9558 44.1132 59.1995 44.2921C62.7383 46.8909 63.3257 51.9446 60.4778 55.285C60.2817 55.5148 60.0093 55.7862 59.468 56.327C58.7659 57.0284 58.4147 57.3812 57.9784 57.7664C52.0897 62.9652 42.4996 63.7213 35.6955 59.7931C25.6199 53.9759 8.28974 36.6684 2.46996 26.589C1.40649 24.747 0.702071 22.6962 0.325104 20.5734C0.292817 20.3935 0.259426 20.2136 0.232005 20.0327C-0.00882099 18.4224 -0.0657313 16.7765 0.0780336 15.1486C0.419391 11.1487 1.90901 7.26141 4.51814 4.30613C4.90355 3.86964 5.25552 3.51573 5.95759 2.81296C6.49801 2.27201 6.76982 2.00272 6.99958 1.80678Z"
              fill="#00008F"
            />
          </Box>
        </Stack>

        <TypographyTranslated
          label={rawHeaderText}
          component={AxaTypography}
          variant="h5"
          align="center"
          sx={{ mt: 5, px: 3 }}
        />

        <TypographyTranslated
          label="login_page.messages.add_alternate_email.description_add_email"
          variant="body2"
          align="center"
          sx={{ my: 2, px: 2 }}
        />

        <TypographyTranslated
          label="login_page.messages.add_alternate_email.description_support_phone"
          variant="body2"
          align="center"
          sx={{ my: 2, px: 2 }}
          variables={{ phoneNumber: SUPPORT_PHONE_NUMBER }}
        />

        <TypographyTranslated
          label="login_page.messages.add_alternate_email.description_contact_support"
          variant="body2"
          align="center"
          sx={{ my: 2, px: 2 }}
        />

        <Stack direction="row" gap={2} justifyContent="center" sx={{ mt: 2 }}>
          <LoginPageCTASecondary
            data-testid={`${testId}_BackToLoginButton`}
            onClick={onBackToLogin}
            variant="contained"
            sx={{ width: 'max-content', px: 3 }}>
            <TypographyTranslated
              component={AxaTypography}
              label="login_page.messages.add_alternate_email.back_to_login"
            />
          </LoginPageCTASecondary>
        </Stack>
      </AddAlternateEmailPageFormWrapper>
    </>
  );
}
